export function convertToJson(text: string) {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}
